/** What the calendar numbers' colours mean: break-even of the picks' own odds, or parlay profit. */

import type { AnalysisLevel } from '@parlay-picker/shared/analyticsScopes';
import type { ReactElement } from 'react';

export function MarketCalendarLegend({ level }: { level: AnalysisLevel }): ReactElement {
  const items =
    level === 'legs'
      ? [
          { color: 'text-theme-success', text: 'Above break-even' },
          { color: 'text-theme-warning', text: 'Too close to call' },
          { color: 'text-theme-danger', text: 'Below break-even' },
        ]
      : [
          { color: 'text-theme-success', text: 'Units won' },
          { color: 'text-theme-danger', text: 'Units lost' },
        ];
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-4 text-[10px] text-theme-text-tertiary">
      {items.map((item) => (
        <div key={item.text} className="flex items-center gap-1">
          <span className={item.color}>●</span> {item.text}
        </div>
      ))}
    </div>
  );
}
